const initialValues = {
  tempData: {
    skill_group_name: '',
    skill_group_description: '',
    sub_skill_group: [
      {
        sub_skill_group_name: '',
        sub_skill_group_description: '',
      },
    ],
  },
  data: {
    skill_group_name: '',
    skill_group_description: '',
    sub_skill_group: [
      {
        sub_skill_group_name: '',
        sub_skill_group_description: '',
      },
    ],
  },

  draft_sub_skill_group: [],
};
export default initialValues;
